import axios from 'axios';
import { MessageBox, Message } from 'element-ui';
import store from '@/store';
import { getToken, decrypted, decryptedAes, encrypted, afterCutAndappend2 } from '@/utils/auth';
import SettingMer from '@/utils/settingMer';
import { isPhone } from '@/libs/wechat';
import cryptoJs from 'crypto-js';
import Vue from 'vue';
var service = axios.create({
  baseURL: SettingMer.apiBaseURL,
  timeout: 60000
});

// request interceptor
service.interceptors.request.use(function (config) {
  // 发送请求之前做的
  var token = !store.getters.token ? sessionStorage.getItem('token') : store.getters.token;
  if (token) {
    config.headers['Authori-zation'] = token;
  }
  if (/get/i.test(config.method)) {
    config.params = config.params || {};
    config.params.temp = Date.parse(new Date()) / 1000;
  }
  {
    signatureGenerate({}, config.headers);
  }
  return config;
}, function (error) {
  return Promise.reject(error);
});

// response interceptor
service.interceptors.response.use(function (response) {
  var res = response.data;
  if (res.data) {
    if (res.data.modeCode != undefined) {
      //单层加密
      if (res.data.modeCode == '1') {
        var cryptoData = decrypted(res.data.data);
        res = JSON.parse(cryptoData);
      }
      //多层加密
      else if (res.data.modeCode == '2') {
        var _cryptoData = decrypted(res.data.data);
        _cryptoData = decryptedAes(_cryptoData);
        res = JSON.parse(_cryptoData);
      }
    }
  }
  // if the custom code is not 20000, it is judged as an error.
  if (res.code === 401) {
    // to re-login
    Message.error('无效的会话，或者登录已过期，请重新登录。');
    if (window.location.pathname !== '/login') location.href = '/login';
  } else if (res.code === 403) {
    Message.error('没有权限访问。');
  }
  if (res.code !== 200 && res.code !== 401) {
    if (isPhone()) {
      //移动端
      return Promise.reject(res || 'Error');
    }
    Message({
      message: res.message || 'Error',
      type: 'error',
      duration: 5 * 1000
    });
    return Promise.reject(res);
  } else {
    return res.data ? res.data : res;
  }
}, function (error) {
  var errorMessage = error.response && error.response.data && error.response.data.message ? error.response.data.message : error.message;
  Message({
    message: errorMessage,
    type: 'error',
    duration: 5 * 10000
  });
  return Promise.reject(error);
});
function signatureGenerate(data, header) {
  // 参数签名 密钥 + 时间戳 + header参数 + url
  // 密钥
  // random
  var nonce = Math.random().toString(36).substr(2);
  // 时间戳
  var timestamp = new Date().getTime();
  // token
  //  let token = headers.Authorization
  // post参数
  var dataStr = serialize(sort(data));
  // 生成签名
  var a = afterCutAndappend2(SettingMer.PK, '0', 10, 16);
  var a1 = afterCutAndappend2(SettingMer.PK, '0', 28, 16);
  var str = a + timestamp + nonce + a1 + "md5";
  //每个用户动态数据
  // 发送请求之前做的
  var token = !store.getters.token ? sessionStorage.getItem('token') : store.getters.token;
  if (token) {
    if (SettingMer.CODE_PK != '') {
      str = afterCutAndappend2(SettingMer.CODE_PK, '0', 0, 4) + str;
    }
  }
  str = dataStr + str;
  var sign = cryptoJs.MD5(str).toString();
  header.m = timestamp;
  header.o = nonce;
  header.sign = sign;
}

// 参数排序
function sort(obj) {
  if (JSON.stringify(obj) == "{}" || obj == null) {
    return {};
  }
  var key = Object.keys(obj).sort();
  var newObj = {};
  for (var i = 0; i < key.length; i++) {
    newObj[key[i]] = obj[key[i]];
  }
  return newObj;
}

// 参数序列化
function serialize(sortObj) {
  var strJoin = '';
  for (var key in sortObj) {
    strJoin += key + "=" + sortObj[key] + "&";
  }
  return strJoin;
}
export default service;